import {
  Button, Space, Spin, Table,
} from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRequest } from 'ahooks';
import FilterType from '@/components/FilterType/FilterType';
import { getDictType } from '@/services/common';
import { XMDD_STATUS } from '@/utils/mappingDict';
import './index.less';
import { getMyProjectList } from '@/services/projectScheduling';

const startYear = 2024;
const endYear = new Date().getFullYear(); // 当前年份
const years = Array.from({ length: endYear - startYear + 1 }, (_, i) => {
  const item = { val: startYear + i, name: startYear + i };
  return item;
});
export default function Index() {
  const Navigate = useNavigate();
  const [val, setVal] = useState({});

  const { data: dict = {} } = useRequest(getDictType, { // 筛选项字典
    defaultParams: [XMDD_STATUS],
  });
  const { data, loading, run } = useRequest(getMyProjectList, { // 列表
    manual: true,
  });

  useEffect(() => {
    run({});
  }, []);

  function handleChange(e, type) {
    setVal({ ...val, [type]: e });
    run({ ...val, [type]: e });
  }
  function handleDetail(e) {
    Navigate(`/projectScheduling/myProject/detail?id=${e.applicationId}&type=${e.type}`);
  }
  function handleEdit(e) {
    const url = e.type === 1 ? '/agrProductProcessingProjects' : '/hundredBillionAgrProject';
    Navigate(`/projectScheduling${url}?id=${e?.applicationId}`);
  }
  const columns = [
    {
      title: '项目类型',
      dataIndex: 'projectType',
      width: 200,
    },
    {
      title: '立项年度',
      dataIndex: 'initiationYear',
      width: 120,
      ellipsis: true,
    },
    {
      title: '所属产业链',
      dataIndex: 'industryChainBelongs',
      width: 120,
    },
    {
      title: '项目名称',
      dataIndex: 'projectName',
      ellipsis: true,
    },
    {
      title: '项目所属区域',
      dataIndex: 'projectArea',
      width: 150,
    },
    {
      title: '填报日期',
      dataIndex: 'gmtCreate',
      width: 140,
    },
    {
      title: '操作',
      key: 'action',
      width: 120,
      fixed: 'right',
      render: (_, record) => (
        <Space size="small">
          <Button type="link" size="small" onClick={() => handleDetail(record)}>
            详情
          </Button>
          <Button type="link" size="small" onClick={() => handleEdit(record)}>
            编辑
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div className="project-scheduling-list">
      <Spin spinning={loading}>
        <div className="content-width">
          <div className="myapplication__title">我的项目</div>
          <div className="myapplication__filter">
            <FilterType title="项目类型" data={dict[XMDD_STATUS]} onChange={(e) => handleChange(e, 'applicationType')} />
            <FilterType title="立项年度" data={years} onChange={(e) => handleChange(e, 'initiationYears')} />
          </div>
          <div className="myapplication__list">
            <Table
              columns={columns}
              dataSource={data}
              loading={loading}
              rowKey="id"
              scroll={{ x: 1200 }}
              pagination={{
                pageSize: 10,
                total: data?.length,
                showTotal: (total) => `共 ${total} 条`,
              }}
            />
          </div>
        </div>
      </Spin>
    </div>
  );
}
